import { Component } from 'opus-angular-seed-core';

@Component({
    transclude: true,
    bindings: {
        error: '=',
        additionalClasses: '<' // just provide space separated classes
    },
    template: `
        <div class="row-wide" ng-class="{ 'has-error': vm.error, '{{ vm.additionalClasses}}': vm.additionalClasses }" ng-transclude></div>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/form/row/wide/index.js